<template>
  <div id="author-dialog">
    <el-dialog
      title="添加授权"
      :visible.sync="dialog"
      width="45%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
      >
        <el-form-item label="对象类型" prop="targetType">
          <el-select
            v-model="ruleForm.targetType"
            placeholder=""
            :disabled="activeIndex === 'DiRes'"
            @change="typeChange"
          >
            <el-option label="USER" value="USER"></el-option>
            <el-option label="GROUP" value="GROUP"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="授权对象" prop="targetIds">
          <el-select
            multiple
            collapse-tags
            filterable
            v-model="ruleForm.targetIds"
            placeholder=""
          >
            <el-option
              v-for="item in targetOptions"
              :key="item.name + '' + item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资源路径" prop="resPath">
          <el-select
            filterable
            allow-create
            v-model="ruleForm.resPath"
            placeholder="请选择或输入路径"
          >
            <el-option
              v-for="(item, i) in pathOptions"
              :key="i"
              :label="item.path"
              :value="item.path"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="授权类型" prop="accessType">
          <el-select v-model="ruleForm.accessType" placeholder="">
            <el-option
              v-for="item in accOptions[activeIndex]"
              :label="item"
              :value="item"
              :key="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :disabled="loading" @click="resetForm('ruleForm')"
          >取消</el-button
        >
        <el-button
          :loading="loading"
          type="primary"
          @click="submitForm('ruleForm')"
          >立即创建</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "author-dialog",
  props: {
    activeIndex: {
      type: String,
      default: ""
    },
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      accOptions: {},
      targetOptions: [],
      pathOptions: [],
      ruleForm: {
        targetType: "USER",
        targetIds: [],
        resPath: "",
        accessType: ""
      },
      rules: {
        targetIds: [
          {
            type: "array",
            required: true,
            message: "请选择用户或组",
            trigger: "change"
          }
        ],
        targetType: [
          {
            required: true,
            message: "请选择授权对象类型",
            trigger: "change"
          }
        ],
        resPath: [
          {
            required: true,
            message: "请选择或输入资源地址",
            trigger: "change"
          }
        ],
        accessType: [
          {
            required: true,
            message: "请选择授权类型",
            trigger: "change"
          }
        ]
      }
    };
  },
  mounted() {
    this.getaccessType();
    this.remoteMethod();
  },
  watch: {
    activeIndex: {
      immediate: true,
      handler() {
        this.remotePath();
        if (this.activeIndex === "DiRes") {
          this.ruleForm.targetType = "GROUP";
          this.typeChange();
        }
      }
    }
  },
  methods: {
    getaccessType() {
      this.$http.get("/gavial/v1/permission/res/accesstype").then(res => {
        this.accOptions = res.data.data;
      });
    },
    remoteMethod() {
      let url = "/gavial/v1/permission/search/group?keyWord=";
      if (this.ruleForm.targetType === "USER") {
        url = "/gavial/v1/permission/search/user?keyWord=";
      }
      this.$http.get(url).then(res => {
        this.targetOptions = res.data.data;
      });
    },
    remotePath() {
      this.$http
        .get(
          "/gavial/v1/permission/res/list?resType=" +
            this.activeIndex +
            "&keyWord="
        )
        .then(res => {
          this.pathOptions = res.data.data;
        });
    },
    typeChange() {
      this.ruleForm.targetIds = [];
      this.remoteMethod();
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit("update:dialog", false);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.addAuthor();
        } else {
          return false;
        }
      });
    },
    addAuthor() {
      this.loading = true;
      this.ruleForm.resType = this.activeIndex;
      this.$http
        .post("/gavial/v1/permission/res/auth/grant", this.ruleForm)
        .then(() => {
          this.$notify({
            title: "成功",
            message: "添加成功",
            type: "success",
            duration: 2000
          });
          this.resetForm("ruleForm");
          this.$emit("refush", this.activeIndex);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
  &:nth-child(2) {
    width: 50%;
  }
}
</style>
